import * as React from 'react';

function SvgEmojiSunglassesFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 16A8 8 0 108 0a8 8 0 000 16zM2.31 5.243A1 1 0 013.28 4H6a1 1 0 011 1v.116A4.22 4.22 0 018 5c.35 0 .69.04 1 .116V5a1 1 0 011-1h2.72a1 1 0 01.97 1.243l-.311 1.242A2 2 0 0111.439 8H11a2 2 0 01-1.994-1.839A2.99 2.99 0 008 6c-.393 0-.74.064-1.006.161A2 2 0 015 8h-.438a2 2 0 01-1.94-1.515L2.31 5.243zM4.969 9.75A3.498 3.498 0 008 11.5a3.498 3.498 0 003.032-1.75.5.5 0 11.866.5A4.498 4.498 0 018 12.5a4.498 4.498 0 01-3.898-2.25.5.5 0 01.866-.5z' />
		</svg>
	);
}

export default SvgEmojiSunglassesFill;
